import { useSyncExternalStore } from "react";

import { adminCourseStore, adminKeyStore, apiKeyStore, subscribe } from "@/lib/auth";

/**
 * The stored student API key, or null.
 *
 * useSyncExternalStore keeps every component consistent when the key changes,
 * including changes made in another browser tab.
 */
export function useApiKey(): string | null {
  return useSyncExternalStore(subscribe, apiKeyStore.get, () => null);
}

export function useAdminKey(): string | null {
  return useSyncExternalStore(subscribe, adminKeyStore.get, () => null);
}

/** The course the admin views are scoped to, or null before one is chosen. */
export function useAdminCourse(): string | null {
  return useSyncExternalStore(subscribe, adminCourseStore.get, () => null);
}
